module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADVSURBVHgB7dW/DsFQFAbwU7ELfQiDoYvBixjZxOhZjIzSjU3ShUSCQcTkGURioEy60e9ENw73n6nfcm/S5Jdz2ntuvUcacpACOcr/4Ut8pWi25NUqvNntKZqvqD8ItfCPcKMekF8u0Tm+0XA0oXuSkBW4kqK9bovxw/HElavg4sczwb+eCl38p+P2DrcCZ3in3eQ98MV6awdG++F4yntUHtSq5jBQtI9K/ddrQQdGsA6KFKWHmDgMhyoqwkBRKSZPFUXEu0IXFSvGXZGtqiji5X8Q5/ATAip6yWwp2HYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_right.png
// module id = cwTc
// module chunks = 1